<template>
  <td>{{ props.project.code }}</td>
  <td>{{ props.project.name }}</td>
  <td>{{ props.project.createdBy.lastName }}, {{ props.project.createdBy.firstName }}</td>
  <td>{{ props.project.assigneesCount }}</td>
  <td>{{ parseDate(props.project.createdAt) }}</td>
  <td>
    <div class="updated-by" v-if="props.project.updatedBy.id != 0">
      <span class="text-truncate">{{ props.project.updatedBy.lastName }}, {{ props.project.updatedBy.firstName }}</span>
      <span>{{ parseDate(props.project.updatedAt) }}</span>
    </div>
    <div v-else>-</div>
  </td>
  <td>
    <div class="action-column">
      <SPALozenge class="text-uppercase" :text="props.project.status" :variant="checkStatusVariant(props.project.statusId)" />
      <MDBDropdown v-model="rowOverflow" class="kebab" v-if="isEditor">
        <MDBDropdownToggle @click.stop="rowOverflow = !rowOverflow">
          <span class="SproutIcon SproutIcon-kebabv-solid"></span>
        </MDBDropdownToggle>
        <MDBDropdownMenu aria-labelledby="dropdownMenuButton">
          <MDBDropdownItem href="#" @click.stop.prevent="dropdownAction(props.project, 'edit')">Edit Project</MDBDropdownItem>
          <MDBDropdownItem href="#" @click.stop.prevent="dropdownAction(props.project, 'assign')">Manage Assignees</MDBDropdownItem>
        </MDBDropdownMenu>
      </MDBDropdown>
    </div>
  </td>
</template>

<script>
import { MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem } from 'mdb-vue-ui-kit';
import { storeToRefs } from 'pinia';
import { parseDate } from '../../../../helpers/dateParser';
import { checkStatusVariant } from '../../Business/ProjectTaggingBusiness';
import { useRouteAccessStore } from '../../../../stores/routeAccess';
import { AccessLevelEnum } from '../../../../enums/accessLevel';
import { computed, ref } from 'vue';
import { useDebounceFn } from '@vueuse/core';
import SPALozenge from '../../../../components/SPALozenge.vue';
import { useProjectTaggingStore } from '../../../../stores/projectTagging';
export default {
  components: {
    MDBDropdown,
    MDBDropdownToggle,
    MDBDropdownMenu,
    MDBDropdownItem,
    SPALozenge,
  },
  props: {
    project: {
      type: Object,
    },
  },
  setup(props) {
    const projectTagging = useProjectTaggingStore();
    const {
      projects,
      projectsPagination,
      isLoading,
      createModalState,
      projectCode,
      projectName,
      projectStatus,
      editModalState,
      projectId,
      drawerState,
      drawerListContainerLoader,
      viewProject,
      projectNameDescription,
    } = storeToRefs(projectTagging);
    const rowOverflow = ref(false);
    const routeAccessStore = useRouteAccessStore();
    const isEditor = computed(() => routeAccessStore.routeAccess.accessLevelStatus === AccessLevelEnum.editor);
    const dropdownAction = (row, action) => {
      if (!isEditor.value) return;
      if (action == 'edit') {
        projectCode.value = row.code;
        projectName.value = row.name;
        projectNameDescription.value = row.name;
        projectStatus.value = row.statusId;
        projectId.value = row.id;
        createModalState.value = true;
        editModalState.value = true;
      } else {
        projectName.value = row.name;
        projectNameDescription.value = row.name;
        projectId.value = row.id;
        drawerListContainerLoader.value = true;
        projectTagging.getEmployeeLookup({});
        toggleDrawer();
      }
      rowOverflow.value = false;
    };
    const toggleDrawer = () => {
      if (viewProject.value) {
        viewProject.value = false;
        debouncedDrawer();
      } else {
        drawerState.value = true;
      }
    };
    const debouncedDrawer = useDebounceFn(() => {
      drawerState.value = true;
    }, 1000);

    return {
      rowOverflow,
      projects,
      projectsPagination,
      parseDate,
      isLoading,
      checkStatusVariant,
      dropdownAction,
      createModalState,
      projectCode,
      projectName,
      projectStatus,
      isEditor,
      props,
    };
  },
};
</script>
<style lang="scss" scoped>
@use '@/assets/sass/announcement-module.scss' as *;
.action-column {
  display: flex;
  width: min-content;
  margin-left: auto;
  align-items: center;
  .spa-lozenge {
    height: min-content;
  }
}
:deep(.dropdown) {
  &.kebab {
    .SproutIcon-kebabv-solid {
      font-size: 16px;
      color: $green-400;
      line-height: revert;
    }
    .dropdown-toggle {
      width: 24px;
      margin: 0 0 0 8px;
      border: none;
      background-color: transparent;
      box-shadow: unset;
      padding: 3px;
      vertical-align: -webkit-baseline-middle;
      &:hover {
        background-color: $neutral-0;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
      }
      &::after {
        display: none;
      }
    }
  }
}
.updated-by {
  display: grid;
  :not(span.text-truncate) {
    color: $neutral-400;
    font-size: 12px;
  }
}
</style>
